export const PRICING_PAGE_SEO = {
  shortTitle: "定價｜付費會員計劃",
  title: "定價｜付費會員計劃｜Skoltend",
  description:
    "Skoltend 付費會員年費 HK$5,888，解鎖全港學校招標完整資料，包括學校名稱、聯絡人、電話及電郵，並可接收電郵及 Telegram 即時通知。",
  keywords: "學校招標訂閱,香港學校tender會員,招標通知,學校聯絡資料",
} as const;
